/** @jsx jsx */
import { React, classNames, jsx, css, polished, hooks } from 'jimu-core';
import { Popper } from '../overlay/popper';
import { useTheme } from 'jimu-theme';
import defaultMessages from '../../translations/default';
const useStyle = () => {
    const theme = useTheme();
    const dark = theme === null || theme === void 0 ? void 0 : theme.ref.palette.neutral[1200];
    const white = theme === null || theme === void 0 ? void 0 : theme.ref.palette.white;
    const gray700 = theme === null || theme === void 0 ? void 0 : theme.ref.palette.neutral[1000];
    const fontSize = theme === null || theme === void 0 ? void 0 : theme.sys.typography.label2.fontSize;
    return React.useMemo(() => {
        return css `
    background: ${white};
    width: ${polished.rem(300)};
    overflow: hidden;
    font-size: ${fontSize};
    color: ${dark};
    padding: 8px;
    margin-top: 10px;
    z-index: 51;
    .linkto {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      word-break: break-all;
      word-wrap: break-word;
      span {
        color: ${gray700};
        text-decoration: underline;
      }
    }
  `;
    }, [dark, white, gray700, fontSize]);
};
export const LinkTip = ({ open = true, reference, placement = 'bottom', className, href }) => {
    const style = useStyle();
    const translate = hooks.useTranslation(defaultMessages);
    return (jsx(Popper, { open: open, reference: reference, placement: placement, className: classNames('shadow', className), css: style },
        jsx("div", { className: 'linkto' },
            translate('linkToString'),
            ": ",
            jsx("span", null, href)),
        jsx("div", null, translate('linkPreviewTip'))));
};
